import { render } from "./Basic.vue?vue&type=template&id=2f697e4c"
import script from "./Basic.vue?vue&type=script&lang=js"
export * from "./Basic.vue?vue&type=script&lang=js"

import "./Basic.vue?vue&type=style&index=0&id=2f697e4c&lang=css"

import exportComponent from "D:\\project\\famousBuild\\famous-build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__